import React from 'react';
import { injectIntl, FormattedNumber } from 'react-intl';
import { connect } from 'react-redux';

class OrderServiceCarInsuranceData extends React.Component {
  render() {
    const { intl, appIntl, service, entity } = this.props;
    const messages = intl.messages;

    return (
      <div>
        <dl class="no-margin">
          <dt>{messages.name}</dt>
          <dd>{messages.car_insurance}</dd>

          <dt class="m-t-5">{messages.status}</dt>
          <dd>-</dd>
        </dl>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};

export default injectIntl(connect(mapStateToProps)(OrderServiceCarInsuranceData));
